<template>
  <div class="flex" :style="randomWidth ? width : ''">
    <div
      :class="[
        'size-full animate-pulse rounded duration-1400 ease-linear',
        {
          'bg-alpha-black-10': type === 'default',
          'bg-alpha-black-5': type === 'light',
          'bg-alpha-black-20': type === 'heavy',
          'bone-text-sm': size === ComponentSize.sm,
          'bone-text-default': size === ComponentSize.default,
          'bone-text-lg': size === ComponentSize.xl,
          'bone-text-section': size === ComponentSize.xl2,
          'bone-text-display': size === ComponentSize.xl3,
        },
      ]"
    />
  </div>
</template>

<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      size?: ComponentSize;
      type?: "default" | "heavy" | "light";
      randomWidth?: boolean;
    }>(),
    {
      size: undefined,
      type: "default",
      randomWidth: false,
    }
  );

  const width = computed(() => {
    if (props.randomWidth) {
      const randomPercentage = Math.floor(Math.random() * 61) + 20; // Random number between 20-80
      return `width: ${randomPercentage}%`;
    }
    return "100%";
  });
</script>

<style>
  .bone-text-sm {
    height: var(--text-body-small);
    margin-block: calc((var(--text-body-small) * var(--text-body-small--line-height) - var(--text-body-small)) / 2);
  }

  .bone-text-default {
    height: var(--text-body-default);
    margin-block: calc(
      (var(--text-body-default) * var(--text-body-default--line-height) - var(--text-body-default)) / 2
    );
  }

  .bone-text-lg {
    height: var(--text-body-large);
    margin-block: calc((var(--text-body-large) * var(--text-body-large--line-height) - var(--text-body-large)) / 2);
  }

  .bone-text-section {
    height: var(--text-heading-section);
    margin-block: calc(
      (var(--text-heading-section) * var(--text-heading-section--line-height) - var(--text-heading-section)) / 2
    );
  }

  .bone-text-display {
    height: var(--text-heading-display);
    margin-block: calc(
      (var(--text-heading-display) * var(--text-heading-display--line-height) - var(--text-heading-display)) / 2
    );
  }
</style>
